"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, upload, Flash) {
  $scope.collectionName = null;
  $scope.importThesaurus = false;
  $scope.selectOption = function(option) {
    $scope.option = option;
    if (option == 'all') {
      $scope.collectionName = null;
    }
  };
  var getUploadButton = function() {
    return $('.tab-pane.active input.btn-upload[type="file"]');
  };
  $scope.doUploadDocuments = function() {
    $scope.loading = true;
    upload({
      url: '/api/import/document',
      method: 'POST',
      data: {
        file: getUploadButton(),
        dataStr: JSON.stringify({})
      }
    }).then(function(response) {
      var message = '<strong>Erfolgreich impotiert!</strong>.';
      Flash.create('success', message, 5000, {}, true);
    }, function(response) {
      var msg = "Unkown";
      if (hlp.isSet(response.data.message)) {
        msg = response.data.message;
      }
      var message = '<strong>Fehler beim importieren! (' + msg + ')</strong>.';
      Flash.create('danger', message, 0, {}, true);
    }).then(function() {
      $scope.loading = false;
      $scope.fileDocument = null;
      $scope.filenameDocument = null;
    });
  };
  $scope.attachDocumentFile = function() {
    var file = getUploadButton();
    $(file).trigger('click');
  };
  $scope.doUploadInterchange = function() {
    $scope.loading = true;
    upload({
      url: '/api/import/interchange',
      method: 'POST',
      data: {
        file: getUploadButton(),
        dataStr: JSON.stringify({})
      }
    }).then(function(response) {
      var message = '<strong>Erfolgreich impotiert!</strong>.';
      Flash.create('success', message, 5000, {}, true);
    }, function(response) {
      var msg = "Unkown";
      if (hlp.isSet(response.data.message)) {
        msg = response.data.message;
      }
      var message = '<strong>Fehler beim importieren! (' + msg + ')</strong>.';
      Flash.create('danger', message, 0, {}, true);
    }).then(function() {
      $scope.loading = false;
      $scope.fileInterchange = null;
      $scope.filenameInterchange = null;
    });
  };
  $scope.attachInterchangeFile = function() {
    var file = getUploadButton();
    $(file).trigger('click');
  };
  var getCollectionList = function() {
    var params = {};
    $http.get('/api/collection.json', {params: params}).then(function(response) {
      $scope.collectionsList = response.data.collections;
    }, function(response) {});
  };
  var initInputFileHandler = function(id, name) {
    $('input#' + id + '[type="file"]').change(function(e) {
      var fileName = null;
      if (hlp.isSet(e.target.files[0])) {
        fileName = e.target.files[0].name;
      }
      $scope.$apply(function() {
        $scope[name] = fileName;
      });
    });
  };
  var init = function() {
    $scope.option = 'all';
    getCollectionList();
    initInputFileHandler("fileDocument", "filenameDocument");
    initInputFileHandler("fileInterchange", "filenameInterchange");
  }();
};
module.exports = controller;
